import { redirect } from "@tanstack/react-router";

/**
 * Helper to redirect to auth page with return URL
 */
export function redirectToAuth(returnUrl?: string) {
  throw redirect({
    to: "/auth",
    search: { redirect: returnUrl },
  });
}
